import { useRef } from 'react';

import { List } from '@mui/material';

import { Scrollbar } from 'src/components/scrollbar';

import ChatMessageListItem from './ChatMessageListItem';
import { useSmoothScrollToBottom } from './hooks/useScrollToBottom';
import { useChatHistoryContext } from './hooks/useChatHistoryContext';
import { useNotifyOverflowContext } from './hooks/useNotifyOverflowContext';

function ChatMessageList() {
  const { history } = useChatHistoryContext();
  const { notify } = useNotifyOverflowContext();

  const containerRef = useRef<HTMLDivElement>(null);
  useSmoothScrollToBottom(containerRef, notify); // optional: pass duration as 600

  return (
    <Scrollbar
      fillContent
      ref={containerRef}
      sx={{
        height: '100%',
        width: '100%',
        scrollBehavior: 'smooth',
      }}
    >
      <List
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'column',
          flex: 1,
          py: 0,
          gap: '3.5rem',
        }}
        component="div"
        data-testid="chat-message-list"
      >
        {history.messages.map((message, index) => (
          <ChatMessageListItem
            key={index}
            index={index}
            data={message}
            sx={{
              ...(index === history.messages.length - 1 && {
                pb: 0,
              }),
            }}
          />
        ))}
      </List>
    </Scrollbar>
  );
}

export default ChatMessageList;
